import React from "react";
import { Redirect, Route } from "react-router-dom";
import { connect } from "react-redux";

const ProtectedRoute = ({ component: Component, auth, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (auth.isAuthenticated) {
          return <Component {...props} />;
        } else {
          return <Redirect to={{ pathname: "/" }} />;
        }
      }}
    />
  );
};

const mapStateToProps = state => {
  return {
    auth: state.auth
  };
};

const AR = connect(mapStateToProps)(ProtectedRoute);

export { AR as ProtectedRoute };
